// extracted by mini-css-extract-plugin
export default {"FooterLogo":"gv8__SpSSYkCAau7vOMF"};